<template>
  <div class="common">
    <search-form
    :formConfig="formConfig"
    :source="searchData"
    @search="search"
    >
        <template slot="btns">
            <a-button v-if="tabType=='circleEffect'" @click="onRecommend" class="search-btn-item btn-blue-line">推荐</a-button>
            <!-- <a-button v-if="tabType=='circleAll'" :disabled="true" @click="onRecommend" class="search-btn-item btn-blue-line">导出</a-button> -->
        </template>
    </search-form>

    <div class="table-common">
      <a-table
        size="middle"
        :columns="columns"
        :data-source="tableData"
        :pagination="pagination"
        :loading="loading"
        :row-key="(record,index) => record.id+'_'+index"
        @change="handleTableChange"
        bordered
        :locale="{emptyText: '暂无数据'}"
      >
        <template slot="roleCd" slot-scope="text">{{parseRole(text)}}</template>
        <template slot="updateTime" slot-scope="text">{{text | dateFormat('YYYY-mm-dd')}}</template>
      </a-table>
      <div :class="{'table-total':pagination.total>0,'table-total-none':pagination.total==0}">
        共有记录：
        <span class="">{{pagination.total}} 条</span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters,mapMutations} from "vuex"
import {circleQuery} from "@/api/circle.js"
export default {
    props:{
        tabType:{
            type: [String],
            required: false,
            default: function () {
                return ""; //所属tab的分类
            }
        },
        status:{
            type: [String],
            required: false,
            default: function () {
                return "";
            }
        },
    },
    name: "circle-main",
    components:{
    },
    data() {
        return {
            searchData:{
                cstNm:"",
                cstOrgCode:"",
                contactPerson:"",
                ctcPsnTel:"",
            },
            formConfig:[
                {
                    prop: "cstNm",
                    type: "input",
                    label: "企业名称",
                },
                {
                    prop: "cstOrgCode",
                    type: "input",
                    label: "信用代码",
                },
                {
                    prop: "contactPerson",
                    type: "input",
                    label: "联系人",
                },
                {
                    prop: "ctcPsnTel",
                    type: "input",
                    label: "手机号码",
                }
            ],
            columns: [
                {
                    title:"邀请日期",
                    width:"100px",
                    dataIndex: "updateTime",
                    scopedSlots: { customRender: "updateTime" }
                },
                {
                    title:"企业名称	",
                    dataIndex: "cstNm",
                },
                {
                    title:"社会信用代码",
                    dataIndex: "cstOrgCode",
                },
                {
                    title: "联系人",
                    dataIndex: "contactPerson",
                },
                {
                    title: "联系电话",
                    dataIndex: "ctcPsnTel",
                },
                {
                    title: "角色",
                    dataIndex: "roleCd",
                    scopedSlots: { customRender: "roleCd" }
                },
                // {
                //     title: "保理商",
                //     dataIndex: "tenantName",
                // },

            ],
            tableData: [],
            pagination: {
                pageSize: 10,
                current: 1,
                sortField: "",
                sortOrder: "",
                total: 0,
                showSizeChanger:true,
                showQuickJumper:true,
                pageSizeOptions:['5','10', '20', '50','100'],
                showTotal:(total)=>{
                return `共 ${total} 条`
                }
            },
            loading: false,
            selectedRows: [],
            selectedRowKeys:[],

        };
    },
    computed: {
    },
    methods: {
        search(data) {
            this.searchData = data || this.searchData;
            this.getTableData();
        },
        getTableData(){
            this.loading = true;
            const params = {
                tab: this.status,
                cstNm: this.searchData.cstNm,
                cstOrgCode: this.searchData.cstOrgCode,
                contactPerson: this.searchData.contactPerson,
                ctcPsnTel: this.searchData.ctcPsnTel,
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize
            };
            circleQuery(params)
            .then((res)=>{
                this.loading = false;
                this.pagination.total = res.data.grid.total||0;
                this.tableData = res.data.grid.list;
            })
            .catch(err => {
                this.loading = false;
                console.log(err);
            })
        },
        handleTableChange(pagination, filters, sorter) { //表格排序回调
            this.pagination = {
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: this.pagination.total || 0,
            };
            this.getTableData();
        },
        parseRole(roleId) {
            if (this.utils.isUndefined(roleId)) {
                return;
            }
            const resultArray = roleId.split(',');
            let result = '';
            for (let i = 0; i < resultArray.length; i++) {
            if (resultArray[i] === '0') {
                result += '下游客户';
            } else if (resultArray[i] === '1') {
                result += '上游客户';
            }
            if (i < resultArray.length - 1) {
                result += ' , ';
            }
            }
            return result;
        },
        onRecommend(){
            this.MENUAPI.goToOneTab({
                path:"account/circle/recommend",

            })
        },
        refresh(){
            this.selectedRows = [];
            this.selectedRowKeys = [];
            this.getTableData();
        }
    },
    created() {
        this.formConfig = this.formConfig.filter(i => !i.hide);
        this.columns = this.columns.filter(i => !i.hide);
        this.getTableData();
    },
    mounted() {},
    activated() {},
};
</script>
<style scoped>
    .input-content>div{
        margin:10px 20px 20px 0;
    }
    .common /deep/ .search-item-lable {
        min-width: 85px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/account/circle/circle-main.vue